import { render, staticRenderFns } from "./UserRegisterForm.vue?vue&type=template&id=166c1691&scoped=true&"
import script from "./UserRegisterForm.vue?vue&type=script&lang=js&"
export * from "./UserRegisterForm.vue?vue&type=script&lang=js&"
import style0 from "./UserRegisterForm.vue?vue&type=style&index=0&id=166c1691&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166c1691",
  null
  
)

export default component.exports